const megaBytes = 1000000;
export const MINIMUM_FILE_SIZE_TO_BE_RESUMABLE_UPLOAD = 100 * megaBytes;
